import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';

import { CelumButtonModule } from '@celum/common-components/button';
import { CelumIconModule } from '@celum/common-components/icon';
import { CelumProgressCircleModule } from '@celum/common-components/progress-circle';
import { StripHtmlPipe } from '@celum/ng2base/pipes';

import { ProgressItem } from './components/progress-item/progress-item';
import { ProgressSnackbar } from './components/progress-snackbar/progress-snackbar';
import { SimpleSnackbar } from './components/simple-snackbar/simple-snackbar';
import { Snackbar } from './components/snackbar/snackbar';

@NgModule({
  imports: [
    CommonModule,
    ScrollingModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatProgressBarModule,
    MatTooltipModule,
    StripHtmlPipe,
    CelumIconModule,
    CelumProgressCircleModule,
    CelumButtonModule
  ],
  declarations: [SimpleSnackbar, Snackbar, ProgressSnackbar, ProgressItem],
  exports: [SimpleSnackbar, Snackbar, ProgressSnackbar, ProgressItem, TranslatePipe]
})
export class CelumSnackbarModule {}
